// pages/CategoriasPartida.jsx

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/Categorias.css'; // Reutilizar el CSS de categorías de materiales

const CategoriasPartida = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: ''
  });

  useEffect(() => {
    cargarCategorias();
  }, []);

  const cargarCategorias = async () => {
    try {
      setLoading(true);
      const response = await api.get('/categorias-partida');
      setCategorias(response.data);
    } catch (error) {
      console.error('Error cargando categorías:', error);
      alert('Error al cargar categorías');
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = (categoria = null) => {
    if (categoria) {
      setEditando(categoria.id);
      setFormData({
        nombre: categoria.nombre,
        descripcion: categoria.descripcion || ''
      });
    } else {
      setEditando(null);
      setFormData({
        nombre: '',
        descripcion: ''
      });
    }
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setEditando(null);
    setFormData({
      nombre: '',
      descripcion: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      alert('El nombre es obligatorio');
      return;
    }

    try {
      if (editando) {
        await api.put(`/categorias-partida/${editando}`, formData);
        alert('Categoría actualizada exitosamente');
      } else {
        await api.post('/categorias-partida', formData);
        alert('Categoría creada exitosamente');
      }
      cerrarModal();
      cargarCategorias();
    } catch (error) {
      console.error('Error guardando categoría:', error);
      alert(error.response?.data?.error || 'Error al guardar categoría');
    }
  };

  const eliminarCategoria = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta categoría?')) return;

    try {
      await api.delete(`/categorias-partida/${id}`);
      alert('Categoría eliminada exitosamente');
      cargarCategorias();
    } catch (error) {
      console.error('Error eliminando categoría:', error);
      alert(error.response?.data?.error || 'Error al eliminar categoría');
    }
  };

  if (loading) {
    return (
      <div className="categorias-container">
        <div className="loading">Cargando categorías...</div>
      </div>
    );
  }

  return (
    <div className="categorias-container">
      <div className="categorias-header">
        <div>
          <h1>📁 Categorías de Partidas</h1>
          <p className="subtitle">Organiza las partidas estándar por categorías</p>
        </div>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          + Nueva Categoría
        </button>
      </div>

      <div className="categorias-grid">
        {categorias.length === 0 ? (
          <div className="empty-state">
            <p>No hay categorías registradas</p>
            <button className="btn btn-primary" onClick={() => abrirModal()}>
              Crear primera categoría
            </button>
          </div>
        ) : (
          categorias.map((categoria) => (
            <div key={categoria.id} className="categoria-card">
              <div className="categoria-header">
                <h3>{categoria.nombre}</h3>
                <div className="categoria-actions">
                  <button
                    className="btn-icon"
                    onClick={() => abrirModal(categoria)}
                    title="Editar"
                  >
                    ✏️
                  </button>
                  <button
                    className="btn-icon danger"
                    onClick={() => eliminarCategoria(categoria.id)}
                    title="Eliminar"
                  >
                    🗑️
                  </button>
                </div>
              </div>
              {categoria.descripcion && (
                <p className="categoria-descripcion">{categoria.descripcion}</p>
              )}
              <div className="categoria-stats">
                <span className="badge">
                  {categoria.total_partidas || 0} partidas
                </span>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {mostrarModal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editando ? 'Editar Categoría' : 'Nueva Categoría'}</h2>
              <button className="btn-close" onClick={cerrarModal}>
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Ej: Estructura"
                  className="form-control"
                  required
                />
              </div>

              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="Descripción opcional..."
                  className="form-control"
                  rows="3"
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {editando ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoriasPartida;